import React from 'react';
import { motion } from "framer-motion";

import sequirty from '../images/amenities/sequerty.png';
import fire from '../images/amenities/firesafety.png';
import evcharging from '../images/amenities/evcharge.png';
import power from '../images/amenities/power.png';
import parking from '../images/amenities/parking.png';
import fan from '../images/amenities/fan.png';
import gym from '../images/amenities/gym.png';
import stairs from '../images/amenities/stairs.png';

export default function Amenitie({ id }) {
    const amenitie = [
        { img: sequirty, text: '24/7 Security and Surveillance' },
        { img: parking, text: 'Ample Parking Space' },
        { img: power, text: 'Power Backup' },
        { img: fan, text: 'Modern HVAC System' },
        { img: gym, text: 'Gym/Fitness Center' },
        { img: stairs, text: 'Elevators and Escalators' },
        { img: fire, text: 'Fire Safety Measures' },
        { img: evcharging, text: 'EV Charging Stations' },
    ];

    return (
        <div id={ id } className='w-full'>
            {/* Heading */}
            <div className='heading flex w-full items-center justify-center gap-5 px-4 md:px-16 pt-8'>
                <div className='h-2 w-[18%] border-b-[2px] border-black'></div>
                <h2 className='text-2xl md:text-4xl'>Amenities</h2>
                <div className='h-2 w-[18%] border-b-[2px] border-black'></div>
            </div>

            {/* Amenity List - Motion effect */}
            <div className='flex py-8 md:py-16 items-center overflow-hidden w-full'>
                <motion.div
                    className='flex'
                    initial={{ x: 0 }}
                    animate={{ x: '-100%' }}
                    transition={{
                        duration: 40,
                        ease: 'linear',
                        repeat: Infinity,
                        repeatType: 'loop'
                    }}
                >
                    {/* Duplicate amenities for seamless scrolling */}
                    {amenitie.concat(amenitie).map((ameniti, i) => (
                        <div key={i} className='flex flex-col justify-center items-center px-5 md:px-10'>
                            {/* Amenity Image */}
                            <div className='img w-[8rem] h-[8rem] md:w-[15rem] md:h-[15rem]'>
                                <img src={ameniti.img} alt={ameniti.text} />
                            </div>
                            {/* Amenity Text */}
                            <h3 className='text-lg md:text-2xl w-full text-center'>{ameniti.text}</h3>
                        </div>
                    ))}
                    {amenitie.concat(amenitie).map((ameniti, i) => (
                        <div key={i} className='flex flex-col justify-center items-center px-5 md:px-10'>
                            {/* Amenity Image */}
                            <div className='img w-[8rem] h-[8rem] md:w-[15rem] md:h-[15rem]'>
                                <img src={ameniti.img} alt={ameniti.text} />
                            </div>
                            {/* Amenity Text */}
                            <h3 className='text-lg md:text-2xl w-full text-center'>{ameniti.text}</h3>
                        </div>
                    ))}
                </motion.div>
            </div>
        </div>
    );
}
